import classnames from 'classnames';

export default function Button(props) {
	const { onClick, role, type = 'button', className, children } = props;
	const optional = {};

	if (role) {
		optional.role = role;
	}

	for (const key in props) {
		if (key.startsWith('aria-') || key.startsWith('data-')) {
			optional[key] = props[key];
		}
	}

	return (
		<div
			className={classnames(
				{
					'ribbon-button': true
				},
				className
			)}
		>
			<button
				className='ribbon-button__button'
				type={type}
				onClick={onClick}
				{...optional}
			>
				{children}
			</button>
		</div>
	);
}
